import React from 'react'
import { leagueIds } from 'src/constants'
import { networkLogos } from 'src/constants/networkLogos'
import { isUSFreeTrial } from 'src/modules/utils/constants'

export const verizonFiosData = {
  competitor: 'Verizon Fios',
  competitorColor: '#FFFFFF',
  heroData: {
    title: 'Looking for the best streaming service?',
    subtitle:
      'Compare Fubo streaming service and Verizon Fios More Fios TV on price, features, channels and add-ons to see which is better for you.',
  },
  generalCompareData: {
    heading: 'Compare Fubo vs. Verizon Fios TV',
    subheading:
      "Here's a general look at both to help you determine which is the best option for live TV entertainment.",
    listItems: ['Channel Count', 'Cloud DVR', 'Simultaneous Streams', 'Starting Price'],
    fuboList: ['200+', 'Unlimited hours', 'Up to 10', '$73.99/mo.*'],
    competitorList: ['325+', 'Limited storage (additional monthly fee)', 'Up to 2', '$129+/mo.*'],
    note: '*Prices may vary with taxes and fees. Prices subject to change. Verizon Fios pricing may include additional equipment rental and setup fees.',
  },
  prosConsData: {
    heading: 'Pros and Cons: Fubo vs. Verizon Fios TV',
    content: (
      <>
        <p>
          When it comes to watching live TV, Fubo and Verizon Fios TV offer two distinct approaches.
          Fubo is a modern, sports-first streaming service designed for flexibility and
          affordability, while Verizon Fios TV is a traditional digital television service delivered
          through a fiber-optic network.
        </p>
        <p>
          Fubo is a premium streaming service with a sports-first approach, offering 200+ live
          channels, including 50+ sports networks and extensive local sports coverage. It delivers
          Unlimited Cloud DVR storage, up to 10 simultaneous streams, and cutting-edge features like
          4K HDR streaming and Multiview, which lets you watch up to 4 channels at once on supported
          devices. Eligible plans also include ESPN Unlimited, providing access to additional live
          events and original content. Fubo's no-contract model allows users to cancel anytime
          without penalties, making it ideal for cord cutters seeking flexibility.
        </p>
        <p>
          Verizon Fios More Fios TV, on the other hand, provides a traditional TV experience with
          325+ channels, including regional sports networks and premium entertainment options.
          However, it's worth noting that this channel count may include overflow channels,
          music-only channels, and other supplementary content, which can make the actual number of
          viewable entertainment channels lower than the total suggests. It comes with significant
          limitations, including mandatory equipment rental, setup fees, and additional charges for
          DVR service. The basic DVR service allows recording of up to 2 shows at once, while
          premium DVR options increase recording capacity but add to the monthly cost. While Verizon
          Fios offers some regional sports networks, it either lacks or requires an upgrade for the
          comprehensive sports coverage that Fubo provides, including NBA TV, ESPN Deportes and beIN
          Sports. Additionally, its streaming flexibility is limited, with only 2 simultaneous
          streams available through the Fios TV Home app.
        </p>
      </>
    ),
  },
  plansData: {
    heading: 'Compare Fubo Pro vs. Verizon Fios More Fios TV',
    subheading:
      "Let's take a look at the differences between the popular Fubo Pro plan and Verizon Fios More Fios TV.",
    tableData: {
      Plan: ['Pro plan', 'More Fios TV'],
      'Live Channels': ['200+', '325+'],
      'Monthly Price': ['$73.99', '$129+ (with additional fees)'],
      'Equipment Fees': ['$0', '$99 setup fee + equipment rental'],
      'Hours of DVR storage': ['Unlimited', 'Limited storage (additional monthly fee)'],
      'Free Trial': [isUSFreeTrial ? 'Yes' : 'No', 'No'],
      'Multiple active streams': ['Up to 10', 'Up to 2'],
      '4K HDR streaming': [true, false],
      'No contract required': [true, false],
    },
    note: '*Prices may vary with taxes and fees. Prices subject to change. Verizon Fios may require additional equipment rental and setup fees.',
  },
  channelsData: {
    heading: 'Compare Fubo Channels vs. Verizon Fios More Fios TV Channels',
    subheading:
      "This channel comparison chart focuses on what's available among top-watched channels in the Fubo Pro plan vs. Verizon Fios More Fios TV.",
    networksData: [
      { network: networkLogos.abc, fubo: true, competitor: true },
      { network: networkLogos.cbs, fubo: true, competitor: true },
      { network: networkLogos.fox, fubo: true, competitor: true },
      { network: networkLogos.espn, fubo: true, competitor: true },
      { network: networkLogos.fs1, fubo: true, competitor: true },
      { network: networkLogos.nbatv, fubo: true, competitor: false },
      { network: networkLogos.nickelodeon, fubo: true, competitor: true },
      { network: networkLogos.bravo, fubo: true, competitor: true },
      { network: networkLogos.bein, fubo: true, competitor: false },
      { network: networkLogos.nflnetwork, fubo: true, competitor: true },
      { network: networkLogos.espndeportes, fubo: true, competitor: false },
      { network: networkLogos.usa, fubo: true, competitor: true },
      { network: networkLogos.disney, fubo: true, competitor: true },
    ],
  },
  completedChannelsData: {
    heading: 'Complete Channel Comparison',
    subheading:
      'See how the live channel lineups compare between Fubo Pro and Verizon Fios More Fios TV.',
    content: (
      <>
        <p>
          When it comes to watching live TV and sports, Fubo Pro and Verizon Fios More Fios TV offer
          very different approaches. While both services provide a mix of sports, entertainment, and
          news channels, the differences in their offerings and value propositions are significant.
        </p>
        <p>
          Fubo Pro dominates with its 200+ channels, including 50+ sports networks and exclusive
          channels like beIN Sports, PFL, and ONE Championship TV. Sports fans won't find those
          channels on Verizon Fios More Fios TV. Fubo Pro is the ultimate choice for sports
          enthusiasts, offering superior coverage of local sports, major leagues, and international
          competitions. Beyond sports, Fubo Pro includes popular entertainment channels like Bravo,
          Disney Channel, and Nickelodeon, plus Spanish-language channels like Telemundo, making it
          perfect for a variety of households.
        </p>
        <p>
          Verizon Fios More Fios TV offers a traditional TV experience with 325+ channels, including
          major broadcast networks like ABC, CBS, FOX, and NBC. It's important to note that this
          channel count may include overflow channels, music-only channels, and supplementary
          content, which means the actual number of viewable entertainment channels may be lower
          than the total suggests. However, it falls short in sports coverage, lacking premium
          networks that can be found in Fubo Pro. Verizon Fios' TV model requires equipment rentals,
          setup fees, and additional DVR service fees that increase monthly costs. Unlike Fubo's
          Unlimited Cloud DVR storage, Verizon Fios' DVR options are limited and come with
          additional fees. For cord cutters seeking value, flexibility, and comprehensive sports
          coverage, Fubo Pro is the clear winner.
        </p>
      </>
    ),
  },
  faqData: {
    qaData: [
      {
        id: 'fubo-faq-1',
        question: 'What channels does Fubo Pro have vs. Verizon Fios More Fios TV?',
        answer: (
          <p>
            Fubo Pro includes exclusive sports channels like beIN Sports, which Verizon Fios More
            Fios TV does not offer. Fubo also has a broader entertainment lineup with channels like
            Bravo and Nickelodeon.
          </p>
        ),
      },
      {
        id: 'fubo-faq-2',
        question: 'Is Fubo Pro better than Verizon Fios More Fios TV for sports?',
        answer: (
          <p>
            Yes, Fubo Pro is better for sports. It offers more sports channels, including exclusive
            options like beIN Sports, as well as extensive local sports coverage and regional sports
            networks.
          </p>
        ),
      },
      {
        id: 'fubo-faq-3',
        question: 'How much does Fubo Pro cost vs. Verizon Fios More Fios TV?',
        answer: (
          <p>
            Fubo Pro costs $73.99 per month, while Verizon Fios More Fios TV starts at $129 per
            month, plus additional fees for equipment rental and setup. Fubo offers better value per
            channel and includes features like unlimited DVR storage and 4K HDR streaming at no
            extra cost.
          </p>
        ),
      },
      {
        id: 'fubo-faq-4',
        question: 'Does Fubo Pro require a contract?',
        answer: (
          <p>
            No, Fubo Pro does not require a contract. You can cancel anytime without penalties,
            unlike Verizon Fios More Fios TV, which may require a commitment and charge setup fees.
          </p>
        ),
      },
      {
        id: 'fubo-faq-5',
        question: 'Can I stream Fubo Pro on multiple devices?',
        answer: (
          <p>
            Yes, Fubo Pro allows up to 10 simultaneous streams, making it ideal for households with
            multiple viewers. Verizon Fios More Fios TV allows only 2 simultaneous streams through
            its Fios TV Home app.
          </p>
        ),
      },
    ],
  },
  // Show multiple sports (NFL, NBA, NHL, College Basketball, College Football)
  matchtickerSportId: null, // Not needed when using multiple leagues
  matchtickerLeagueName: 'Multiple Sports',
  matchtickerLeagueId: [
    leagueIds.NFL,
    leagueIds.NBA,
    leagueIds.NHL,
    leagueIds["Men's NCAA Basketball"],
    leagueIds['NCAA Football'],
  ],
}
